import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { catchError, of } from 'rxjs';
import { exhaustMap, map, switchMap } from 'rxjs/operators';
import {
  selectAccountInfo,
  selectMasterAccount,
  selectSubAccountId,
  selectUserContext,
} from '../../account-info-header/reducers';
import {
  ServiceErrorWithList
} from '../../create-request/models/shared/ServiceError';
import { DraftsService } from '../../create-request/services/drafts.service';
import { StatusViewService } from '../../shared/services/status-view.service';
import { InitReleaseActions } from '../actions';
import {
  DraftListAttributes,
  DraftResponse,
} from '../Models/Drafts/DraftResponse';
import { concatLatestFrom } from "@ngrx/operators";

@Injectable()
export class intReleaseEffects {
  constructor(
    private actions$: Actions,
    private store: Store,
    private statusViewService: StatusViewService,
    private draftService: DraftsService
  ) {}

  callInitReleaseList$ = createEffect(() =>
    this.actions$.pipe(
      ofType(InitReleaseActions.getInitReleaseList),
      concatLatestFrom(() => [
        this.store.select(selectMasterAccount),
        this.store.select(selectSubAccountId),
        this.store.select(selectUserContext)
      ]),
      exhaustMap(([_action, masterAccount, subAccount, userContext]) => {
        if (masterAccount.length === 7) {
          masterAccount = masterAccount.padStart(8, '0');
        }
        if(userContext.toLowerCase() === 'master'){
          subAccount = '';
        }
        return this.statusViewService
          .getInitReleaseTransactions(masterAccount, subAccount)
          .pipe(
            map((apiResponse: DraftResponse) => {
              return InitReleaseActions.getInitReleaseListSuccessful(
                apiResponse
              );
            }),
            catchError((err: ServiceErrorWithList) =>
              of(InitReleaseActions.getInitReleaseListFailed(err))
            )
          );
      })
    )
  );

  callStatusViewInitRelease$ = createEffect(() =>
    this.actions$.pipe(
      ofType(InitReleaseActions.callInitReleaseByDraftId),
      concatLatestFrom(() => [(this.store.select(selectAccountInfo))]),
      switchMap(([action, accountInfo]) => {
        let draftId = action.draftId;

        return this.statusViewService
          .getInitReleaseTransactionByDraftId(draftId)
          .pipe(
            map((apiResponse: DraftListAttributes) => {
              return InitReleaseActions.initReleaseByDraftIdSuccessful({ response: apiResponse, isSloa: action.isSloa, isNraAccount: accountInfo.info?.classifications?.isNraAccount ?? false});
            }),
            catchError((err: ServiceErrorWithList) =>
              of(InitReleaseActions.initReleaseByDraftIdFailed(err))
            )
          );
      })
    )
  );

  callInitReleaseDelete$ = createEffect(() =>
    this.actions$.pipe(
      ofType(InitReleaseActions.deleteInitiatedDraft),
      switchMap((action) => {
        return this.draftService.callDeleteInitiatedDraft(action.draftId).pipe(
          map((_) => {
            return InitReleaseActions.deleteInitiatedDraftSuccessful();
          }),
          catchError((_) => {
            return of(InitReleaseActions.deleteInitiatedDraftFailed());
          })
        );
      })
    )
  );
}
